import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Server,
  Search,
  Settings,
  Key,
  X,
  Workflow,
  Wrench,
  Network,
  FileText
} from 'lucide-react';

interface SidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}

interface NavItem {
  name: string;
  href: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  { name: 'Dashboard', href: '/dashboard', icon: <LayoutDashboard size={20} /> },
  { name: 'Clients', href: '/clients', icon: <Users size={20} /> },
  { name: 'Servers', href: '/servers', icon: <Server size={20} /> },
  { name: 'Query', href: '/query', icon: <Search size={20} /> },
  { name: 'Prompts', href: '/prompts', icon: <Workflow size={20} /> },
  { name: 'Tools', href: '/tools', icon: <Wrench size={20} /> },
  { name: 'Resources', href: '/resources', icon: <FileText size={20} /> },
  { name: 'Graph', href: '/graph', icon: <Network size={20} /> },
  { name: 'API Keys', href: '/api-keys', icon: <Key size={20} /> },
  { name: 'Settings', href: '/settings', icon: <Settings size={20} /> }
];

export const Sidebar: React.FC<SidebarProps> = ({ isOpen = true, onClose }) => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar - ALWAYS visible on desktop, toggleable on mobile */}
      <aside
        className={`
          w-64 bg-white border-r border-gray-200 flex-shrink-0 h-full
          hidden lg:block
          ${!isOpen ? 'max-lg:hidden' : ''}
          ${isOpen ? 'max-lg:fixed max-lg:top-16 max-lg:bottom-0 max-lg:left-0 max-lg:z-30 max-lg:block' : ''}
        `}
      >
        <div className="h-full flex flex-col">
          {/* Close button (mobile only) */}
          {onClose && (
            <div className="flex justify-end p-4 lg:hidden">
              <button
                onClick={onClose}
                className="text-gray-600 hover:text-gray-900"
              >
                <X size={24} />
              </button>
            </div>
          )}

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                onClick={onClose}
                className={`
                  flex items-center gap-3 px-4 py-3 rounded-lg
                  transition-colors font-medium
                  ${
                    isActive(item.href)
                      ? 'bg-blue-50 text-blue-600'
                      : 'text-gray-700 hover:bg-gray-100'
                  }
                `}
              >
                {item.icon}
                <span>{item.name}</span>
              </Link>
            ))}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200">
            <div className="text-xs text-gray-500 text-center">
              <p>MCP Hub Universal</p>
              <p className="mt-1">v1.0.0</p>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};
